//@flow
// Sendbird is not yet exposing the types, that's why keeping the type as $FixMe for now
export const isOnline = (user: $FixMe): boolean =>
    user.connectionStatus === 'online';

export const getRiderId = (user: $FixMe): string => {
    const { userId } = user;
    return userId ? userId.split('*')[1] : '';
};
